module.exports = __webpack_public_path__ + "media/images/favicon-8f6480941a7d40f87ff73b864fd4cb9c.ico";